import React, { useState, useRef } from 'react';
import NoSaveCamera from '../NoSaveCamera/NoSaveCamera';
import AddPhotoSVG from "./AddPhotoSVG.svg";
import './MediaPicker.scss';

const MediaPicker = ({ onFilesSelected, onCameraCapture }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showNoSaveCamera, setShowNoSaveCamera] = useState(false);
    const galleryInputRef = useRef(null);
    const cameraInputRef = useRef(null);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    // Обработчик для галереи
    const handleGallerySelect = () => {
        galleryInputRef.current?.click();
        closeModal();
    };

    // Обработчик для обычной камеры
    const handleCameraSelect = () => {
        cameraInputRef.current?.click();
        closeModal();
    };

    // Обработчик для камеры без сохранения - теперь сразу открываем камеру
    const handleNoSaveCameraSelect = () => {
        closeModal();
        // Даем небольшую задержку, чтобы модальное окно успело закрыться
        setTimeout(() => {
            setShowNoSaveCamera(true);
        }, 100);
    };

    // Обработчик для файлов из галереи
    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        if (files.length > 0 && onFilesSelected) {
            onFilesSelected(files);
        }
        e.target.value = null;
    };

    // Обработчик для фото из камеры без сохранения
    const handleNoSaveCapture = (photoDataUrl) => {
        if (photoDataUrl && onCameraCapture) {
            onCameraCapture(photoDataUrl);
        }
        setShowNoSaveCamera(false);
    };

    // Закрытие камеры без сохранения
    const handleCloseNoSaveCamera = () => {
        setShowNoSaveCamera(false);
    };

    // Закрытие модалки по клику на оверлей
    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            closeModal();
        }
    };

    return (
        <>
            {/* Кнопка-триггер для открытия модального окна */}
            <div className={`wrapper__file-upload media-picker-trigger`} onClick={openModal}>
                <div className="file-upload">
                    <img src={AddPhotoSVG} alt="add media" loading="lazy"/>
                    <h3 className="file-upload-text">Добавить фото...</h3>
                </div>
            </div>

            {/* Скрытые input'ы */}
            <input
                ref={galleryInputRef}
                type="file"
                multiple={true}
                accept="image/png, image/jpg, image/jpeg, image/webp"
                onChange={handleFileChange}
                style={{ display: 'none' }}
            />

            <input
                ref={cameraInputRef}
                type="file"
                multiple={true}
                accept="image/png, image/jpg, image/jpeg, image/webp"
                onChange={handleFileChange}
                capture={'environment'}
                style={{ display: 'none' }}
            />

            {/* Модальное окно с тремя опциями */}
            {isModalOpen && (
                <div className="media-picker-overlay" onClick={handleOverlayClick}>
                    <div className="media-picker-modal">
                        <button className="media-picker-close" onClick={closeModal}>✕</button>
                        <h3 className="media-picker-title">Выберите источник фото</h3>

                        <div className="media-picker-options">
                            <button
                                className="media-picker-option camera-save"
                                onClick={handleCameraSelect}
                            >
                                <span className="option-icon">📸</span>
                                <span className="option-text">
                                    <strong>Сделать фото</strong>
                                    <small>с сохранением в галерею</small>
                                </span>
                            </button>

                            <button
                                className="media-picker-option gallery"
                                onClick={handleGallerySelect}
                            >
                                <span className="option-icon">🖼️</span>
                                <span className="option-text">
                                    <strong>Выбрать из галереи</strong>
                                    <small>уже готовые фото</small>
                                </span>
                            </button>

                            <button
                                className="media-picker-option no-save"
                                onClick={handleNoSaveCameraSelect}
                            >
                                <span className="option-icon">📱</span>
                                <span className="option-text">
                                    <strong>Сделать фото без сохранения</strong>
                                    <small>не сохраняется в устройстве</small>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Компонент для фото без сохранения */}
            {showNoSaveCamera && (
                <NoSaveCamera
                    onCapture={handleNoSaveCapture}
                    onClose={handleCloseNoSaveCamera}
                    openImmediately={true} // Новый пропс для немедленного открытия
                />
            )}
        </>
    );
};

export default MediaPicker;